"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBraintree = useBraintree;
const react_1 = __importDefault(require("react"));
const braintree_web_1 = __importDefault(require("braintree-web"));
const moment_1 = __importDefault(require("moment"));
const Api = __importStar(require("@src/api"));
function useBraintree() {
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const [braintree3DSecureInstance, setBraintree3DSecureInstance] = react_1.default.useState(null);
    const [braintreeDataCollector, setBraintreeDataCollector] = react_1.default.useState(null);
    const [hostedFieldsInstance, setHostedFieldsInstance] = react_1.default.useState(null);
    const initBraintreeClient = react_1.default.useCallback(async (clientToken) => {
        try {
            const createdBraintreeInstance = await braintree_web_1.default.client.create({
                authorization: clientToken,
            });
            const createdBraintree3DSecureInstance = await braintree_web_1.default.threeDSecure.create({
                client: createdBraintreeInstance,
                version: 2,
            });
            const createdDataCollector = await braintree_web_1.default.dataCollector.create({
                client: createdBraintreeInstance,
            });
            setBraintreeDataCollector(createdDataCollector);
            setBraintree3DSecureInstance(createdBraintree3DSecureInstance);
            return {
                braintreeClient: createdBraintreeInstance,
                braintree3DSecure: createdBraintree3DSecureInstance,
                braintreeDataCollectorInstance: createdDataCollector,
            };
        }
        catch (err) {
            console.error(err);
        }
    }, []);
    const initHostedFields = async (clientToken) => {
        if (hostedFieldsInstance) {
            return hostedFieldsInstance;
        }
        try {
            const createdHostedFieldsInstance = await braintree_web_1.default.hostedFields.create({
                authorization: clientToken,
                styles: {
                    input: {
                        height: '2rem',
                        border: '1px solid black',
                        'font-size': '14px',
                    },
                    'input.invalid': {
                        color: 'red',
                    },
                    'input.valid': {
                        color: 'green',
                    },
                },
                fields: {
                    number: {
                        selector: '#card-number',
                        placeholder: '1111 1111 1111 1111',
                    },
                    cvv: {
                        selector: '#cvv',
                        placeholder: '123',
                    },
                    expirationDate: {
                        selector: '#expiration-date',
                        placeholder: (0, moment_1.default)().format('MM / YYYY'),
                    },
                },
            });
            setHostedFieldsInstance(createdHostedFieldsInstance);
            return createdHostedFieldsInstance;
        }
        catch (err) {
            console.error(err);
        }
    };
    const initCheckout = async (shouldInitHostedFields) => {
        setIsLoading(true);
        const { clientToken } = await Api.Admin.getClientToken();
        const { braintreeClient, braintree3DSecure, braintreeDataCollectorInstance } = (await initBraintreeClient(clientToken));
        let braintreeHostedFields;
        if (shouldInitHostedFields) {
            braintreeHostedFields = await initHostedFields(clientToken);
        }
        setIsLoading(false);
        return {
            braintreeHostedFields,
            braintreeClient,
            braintree3DSecure,
            braintreeDataCollectorInstance,
        };
    };
    return {
        isBraintreeLoading: isLoading,
        initCheckout,
        hostedFieldsInstance,
        setHostedFieldsInstance,
        braintree3DSecureInstance,
        setBraintree3DSecureInstance,
        braintreeDataCollector,
        setBraintreeDataCollector,
    };
}
